import gql from 'graphql-tag';

export const SetAutomaticInvoicingConfig = gql`
    mutation SetAutomaticInvoicingConfig($siteSetId: InstitutionSetId!, $config: AutomaticInvoicingConfigInput!) {
        finance {
            invoices {
                automaticInvoicing {
                    setAutomaticInvoicingConfig(siteSetId: $siteSetId, config: $config) {
                        invoicingPeriod
                        daysUntilPaymentDeadline
                        assignToNewBillPayers {
                            occurrence
                        }
                        configurationInheritance {
                            canBeConfigured
                        }
                        monthly {
                            option
                            exactDay
                            invoicingDue {
                                __typename
                                ... on DayOfMonthDue {
                                    type
                                    exactDayOfMonth
                                }
                                ... on MonthlyRelativeToBillingDateDue {
                                    type
                                    daysAfterSendingInvoice
                                }
                                ... on FirstWorkingDayOfMonthDue {
                                    type
                                }
                                ... on LastWorkingDayOfMonthDue {
                                    type
                                }
                            }
                        }
                        weekly {
                            exactDay
                            invoicingDue {
                                __typename
                                ... on DayOfWeekDue {
                                    type
                                    exactDayOfWeek
                                }
                                ... on WeeklyRelativeToBillingDateDue {
                                    type
                                    daysAfterSendingInvoice
                                }
                            }
                        }
                        biweekly {
                            startDate
                            nextInvoicingDate
                            invoicingDue {
                                __typename
                                ... on DayOfWeekDue {
                                    type
                                    exactDayOfWeek
                                }
                                ... on WeeklyRelativeToBillingDateDue {
                                    type
                                    daysAfterSendingInvoice
                                }
                            }
                        }
                        sendInvoicesAutomatically
                    }
                }
            }
        }
    }
`;

export const FetchAutomaticInvoicingConfig = gql`
    query FetchAutomaticInvoicingConfig($siteSetId: InstitutionSetId!) {
        finance {
            invoices {
                automaticInvoicing {
                    isOnUsCorePackage(siteSetId: $siteSetId)
                    automaticInvoicingConfig(siteSetId: $siteSetId) {
                        invoicingPeriod
                        daysUntilPaymentDeadline
                        assignToNewBillPayers {
                            occurrence
                        }
                        configurationInheritance {
                            canBeConfigured
                        }
                        monthly {
                            option
                            exactDay
                            invoicingDue {
                                __typename
                                ... on DayOfMonthDue {
                                    type
                                    exactDayOfMonth
                                }
                                ... on MonthlyRelativeToBillingDateDue {
                                    type
                                    daysAfterSendingInvoice
                                }
                                ... on FirstWorkingDayOfMonthDue {
                                    type
                                }
                                ... on LastWorkingDayOfMonthDue {
                                    type
                                }
                            }
                        }
                        weekly {
                            exactDay
                            invoicingDue {
                                __typename
                                ... on DayOfWeekDue {
                                    type
                                    exactDayOfWeek
                                }
                                ... on WeeklyRelativeToBillingDateDue {
                                    type
                                    daysAfterSendingInvoice
                                }
                            }
                        }
                        biweekly {
                            startDate
                            nextInvoicingDate
                            invoicingDue {
                                __typename
                                ... on DayOfWeekDue {
                                    type
                                    exactDayOfWeek
                                }
                                ... on WeeklyRelativeToBillingDateDue {
                                    type
                                    daysAfterSendingInvoice
                                }
                            }
                        }
                        sendInvoicesAutomatically
                    }
                }
            }
        }
    }
`;

export const FetchIsAutomaticDecouplingEnabled = gql`
    query FetchIsAutomaticDecouplingEnabled($siteSetId: InstitutionSetId!) {
        finance {
            invoices {
                automaticInvoicing {
                    isAutomaticDecouplingEnabled(siteSetId: $siteSetId)
                }
            }
        }
    }
`;

export const FetchAutomaticDecouplingAffectedBillPayerCount = gql`
    query FetchAutomaticDecouplingAffectedBillPayerCount(
        $siteSetId: InstitutionSetId!
        $sendInvoicesAutomatically: Boolean!
    ) {
        finance {
            invoices {
                automaticInvoicing {
                    automaticDecouplingToggleCountOfAffectedBillPayers(
                        siteSetId: $siteSetId
                        sendInvoicesAutomatically: $sendInvoicesAutomatically
                    )
                }
            }
        }
    }
`;
